import { Reducer, Action } from 'redux'
import { ITag, ITagsState } from 'types'
import { SHIPMENT_NOTE_TAGS } from 'utils/actions/shipmentNoteTags'

const {
  SHIPMENT_NOTE_TAGS_FAILURE,
  SHIPMENT_NOTE_TAGS_REQUEST,
  SHIPMENT_NOTE_TAGS_SUCCESS,
} = SHIPMENT_NOTE_TAGS

interface ShipmentNoteTagsSuccessAction extends Action<string> {
  payload: {
    response: ITag[]
  }
}
interface ShipmentNoteTagsFailureAction extends Action<string> {
  error: string
}

type ShipmentNoteTagsReducerAction = Action<string> | ShipmentNoteTagsFailureAction

const defaultState = {
  fetching: false,
  list: [],
  error: undefined,
}

const shipmentNoteTagsReducer: Reducer<ITagsState, ShipmentNoteTagsReducerAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case SHIPMENT_NOTE_TAGS_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }

    case SHIPMENT_NOTE_TAGS_SUCCESS: {
      const {
        payload: { response },
      } = action as ShipmentNoteTagsSuccessAction
      return {
        ...state,
        fetch: false,
        list: response,
      }
    }

    case SHIPMENT_NOTE_TAGS_FAILURE: {
      const { error } = action as ShipmentNoteTagsFailureAction
      return {
        ...state,
        fetching: false,
        error,
      }
    }

    default:
      return state
  }
}

export default shipmentNoteTagsReducer
